<yat-icon id="a7c2ef58-bb04-434f-9549-982a9bac980d" [name]="spec.icon.name" [multiColored]="true" class="block text-center"></yat-icon>

<h1 class="text-white-warm-web">
  {{ spec.title | async }}
</h1>

<ng-container *ngIf="spec.type === 'transloco'">
  <p class="c-gray" *ngFor="let description of spec.descriptions">
    <yat-notification-message id="d825d32f-e3f5-42a7-8f13-cd581aa57c96" [message]="description"> </yat-notification-message>
  </p>
</ng-container>
<p class="c-gray" *ngIf="spec.type === 'static'">
  <yat-notification-message id="a78dc711-b92c-44d5-8841-4fad753ab2bf" [staticMessage]="spec.description"> </yat-notification-message>
</p>

<button yat-button #defaultBtn class="btn primary w-100" *ngIf="spec.buttonClick">
  {{ (spec.buttonName ? spec.buttonName : ('close' | commonWording)) | async }}
</button>
